export const socialsData = {
    github: 'https://github.com/RavjodhHeer',
    facebook: 'https://www.facebook.com/profile.php?id=100011257391997',
    linkedIn: 'https://www.linkedin.com/in/ravjodhheer/',
    instagram: 'https://www.instagram.com/ravjodh/',
}